<template>
<div class="chapter">
<div class="inner_page">
<p class="epi1"><a id="page_vii">. . . the ghosts of our future</a></p><a id="page_vii">
<p class="epi">are unpredictable</p>
<p class="epi">and out of control.</p>
<p class="epi"><span class="txit">—Wendy Rose,</span></p>
<p class="epi">from “The Fifties”</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?3188be47